// Client logos supplied by the client (Client_Logo.zip), optimised to 256px WebP in /public/images/clients.
export const CLIENT_LOGOS = [
  { src: "/images/clients/diamond-emblem.webp", alt: "Client logo \u2013 colourful diamond emblem" },
  { src: "/images/clients/georginas-kitchen.webp", alt: "Georgina's Kitchen logo" },
  { src: "/images/clients/cleaning-services.webp", alt: "Cleaning Services logo" },
  { src: "/images/clients/melbourne-carport-builders.webp", alt: "Melbourne Carport Builders logo" },
  { src: "/images/clients/eco-systems-homes.webp", alt: "Eco Systems Homes Kit & Designs logo" },
  { src: "/images/clients/lvp-wholesale.webp", alt: "LVP Wholesale luxury vinyl plank flooring logo" },
  { src: "/images/clients/glm-great-learning.webp", alt: "GLM Great Learning logo" },
  { src: "/images/clients/creative-consulting.webp", alt: "Creative Consulting logo" },
  { src: "/images/clients/doors-n-windows.webp", alt: "Doors N Windows logo" },
  { src: "/images/clients/dhakad-paint-station.webp", alt: "Dhakad Paint Station logo" },
  { src: "/images/clients/dhakad-enterprises.webp", alt: "Dhakad Enterprises logo" },
  { src: "/images/clients/sakshi-farm.webp", alt: "Sakshi Farm logo" },
  { src: "/images/clients/be-hemp-india.webp", alt: "B.E. Hemp India logo" },
  { src: "/images/clients/trustcapital.webp", alt: "TrustCapital Global Technologies logo" },
  { src: "/images/clients/adhiraj-estore.webp", alt: "Adhiraj eStore logo" },
  { src: "/images/clients/sha-foods.webp", alt: "Sha Foods logo" },
  { src: "/images/clients/dr-rammanohar-lohia-institutions.webp", alt: "Dr. Rammanohar Lohia Institutions logo" },
  { src: "/images/clients/pointmark-interiors.webp", alt: "Pointmark Interiors logo" },
  { src: "/images/clients/way-xpress.webp", alt: "Way Xpress packers and movers logo" },
  { src: "/images/clients/rs-grand.webp", alt: "RS Grand events and decorations logo" },
  { src: "/images/clients/dhakad-traders.webp", alt: "Dhakad Traders logo" },
  { src: "/images/clients/cure-by-design.webp", alt: "Cure By Design logo" },
  { src: "/images/clients/manya-matrimony.webp", alt: "Manya Matrimony logo" },
  { src: "/images/clients/rcc-pattern.webp", alt: "RCC Pattern coaching institute logo" },
  { src: "/images/clients/osm-stays.webp", alt: "OSM Stays logo" },
  { src: "/images/clients/blue-star-emblem.webp", alt: "Client logo \u2013 blue triangle star emblem" },
  { src: "/images/clients/lending-square-group.webp", alt: "Lending Square Group logo" },
  { src: "/images/clients/masterkey-locksmith.webp", alt: "Masterkey Locksmith logo" },
  { src: "/images/clients/mayrake.webp", alt: "Mayrake clothing logo" },
  { src: "/images/clients/menocore.webp", alt: "MenoCore logo" },
  { src: "/images/clients/parda-sansar.webp", alt: "Parda Sansar curtains logo" },
  { src: "/images/clients/rigorfield.webp", alt: "Rigorfield logo" },
  { src: "/images/clients/samurai-awards.webp", alt: "Samurai Awards logo" },
  { src: "/images/clients/dhakad-traders-building-supplier.webp", alt: "Dhakad Traders building material supplier logo" },
  { src: "/images/clients/gati-royal.webp", alt: "Gati Royal packers and movers logo" },
  { src: "/images/clients/mobile-savvy.webp", alt: "Mobile Savvy logo" },
  { src: "/images/clients/green-leaf-emblem.webp", alt: "Client logo \u2013 green leaf emblem" },
  { src: "/images/clients/cc-moments.webp", alt: "C&C Moments logo" },
  { src: "/images/clients/mapvanta.webp", alt: "Mapvanta logo" },
];
